module.exports = __webpack_public_path__ + "img/sweep.44bfde33.svg";